import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Box, Typography, Container, Alert } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { useT, useLang } from './i18n/langContext';
import privacyIt from './legal/privacy.it';
import privacyEn from './legal/privacy.en';

const BODIES = { it: privacyIt, en: privacyEn };
const SECTION_KEYS = ['dataCollected', 'legalBasis', 'retention', 'thirdParties', 'yourRights'];

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" sx={{ fontFamily: theme.home.display, fontWeight: 700, mb: 1.5 }}>{title}</Typography>
      <Typography sx={{ color: theme.home.inkMuted, lineHeight: 1.7 }}>{children}</Typography>
    </Box>
  );
}

function PrivacyPolicy() {
  const t = useT();
  const { lang } = useLang();
  const body = BODIES[lang] || BODIES.it;
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: theme.home.paper, color: theme.home.ink, minHeight: '100vh' }}>
        <Navbar />
        <Container maxWidth="md" sx={{ py: { xs: 6, md: 10 } }}>
          <Typography variant="h3" sx={{ fontFamily: theme.home.display, fontWeight: 800, mb: 1 }}>
            {t('privacy.title')}
          </Typography>
          <Typography sx={{ color: theme.home.inkMuted, mb: 5 }}>{t('privacy.lastUpdated')}</Typography>

          {lang === 'en' && (
            <Alert severity="warning" sx={{ mb: 4 }}>{t('legal.draftNotice')}</Alert>
          )}

          {SECTION_KEYS.map((key) => (
            <Section key={key} title={t(`privacy.sections.${key}`)}>{body[key]}</Section>
          ))}
        </Container>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default PrivacyPolicy;
